import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { showMessage } from 'app/store/fuse/messageSlice';

export const getCourse = createAsyncThunk('academyApp/course/getCourse', async (courseId) => {
  //const responseMock = await axios.get(`/api/academy/courses/${courseId}`);
  const response = await axios.get(process.env.REACT_APP_API_URL + 'curso/'+courseId);

  //const dataMock = await responseMock.data;
  const data = await response.data[0];

  return data;
});

export const updateCourse = createAsyncThunk(
  'academyApp/course/updateCourse',
  async (_data, { getState, dispatch }) => {
    const { id } = getState().academyApp.course;

    console.log('put', _data, id);
    //const responseMock = await axios.put(`/api/academy/courses/${id}`, _data);
    const response = await axios.put(process.env.REACT_APP_API_URL + 'curso-step/'+id, _data);

    const data = await response.data[0];
    //const dataMock = await responseMock.data;

    dispatch(showMessage({ message: 'Course Saved' }));

    return data;
  }
);

const courseSlice = createSlice({
  name: 'academyApp/course',
  initialState: null,
  reducers: {},
  extraReducers: {
    [getCourse.fulfilled]: (state, action) => action.payload,
    [updateCourse.fulfilled]: (state, action) => action.payload,
  },
});

export const selectCourse = ({ academyApp }) => academyApp.course;

export default courseSlice.reducer;
